/*
  RAWS cart discount code: one slim "Add discount code  +" row above the totals in the cart drawer
  and on the cart page (like Shopify checkout's discount row), in the storefront language
  (DISC_TEXT, by <html lang>). Tapping it pops out a compact code field, so the totals and pay
  buttons only move for shoppers who ask for it. Applied codes show as small chips with an x.
  Styles: assets/raws-cart-discount.css. Both files are loaded from layout/theme.liquid.

  Shopify's /cart/update.js `discount` parameter replaces the cart's codes with the comma-separated
  list it's given, so we always send the codes that already work plus the new one. A code that
  doesn't apply is taken off again and a short message is shown, so a working code is never lost.
  The same request asks for the drawer / cart page section, and the theme's own update path
  (Aurora: mount() + emit('update-nodes')) redraws the totals, like a quantity change does.
  The theme rebuilds the cart footer on every update, so a MutationObserver puts the box back.
*/
(function () {
  'use strict';
  if (window.__rawsCartDiscount) return;
  window.__rawsCartDiscount = true;

  var DISC_TEXT = {
    en: { ph: 'Add discount code', code: 'Discount code', apply: 'Apply', err: 'This code can’t be applied', remove: 'Remove' },
    de: { ph: 'Rabattcode hinzufügen', code: 'Rabattcode', apply: 'Anwenden', err: 'Dieser Code kann nicht angewendet werden', remove: 'Entfernen' },
    fr: { ph: 'Ajouter un code de réduction', code: 'Code de réduction', apply: 'Appliquer', err: 'Ce code ne peut pas être appliqué', remove: 'Supprimer' },
    nl: { ph: 'Kortingscode toevoegen', code: 'Kortingscode', apply: 'Toepassen', err: 'Deze code kan niet worden toegepast', remove: 'Verwijderen' },
    es: { ph: 'Añadir código de descuento', code: 'Código de descuento', apply: 'Aplicar', err: 'Este código no se puede aplicar', remove: 'Eliminar' },
    it: { ph: 'Aggiungi codice sconto', code: 'Codice sconto', apply: 'Applica', err: 'Questo codice non può essere applicato', remove: 'Rimuovi' },
    ja: { ph: '割引コードを追加', code: '割引コード', apply: '適用', err: 'このコードは適用できません', remove: '削除' },
    ko: { ph: '할인 코드 추가', code: '할인 코드', apply: '적용', err: '이 코드는 적용할 수 없습니다', remove: '삭제' }
  };
  var lang = String(document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  var T = DISC_TEXT[lang] || DISC_TEXT.en;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var codes = null; // codes that currently apply to the cart (null until read)
  var busy = false;
  var isOpen = false; // code field open (kept while the theme redraws the cart)

  function same(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }

  function workingCodes(cart) {
    return ((cart && cart.discount_codes) || [])
      .filter(function (d) { return d && d.applicable; })
      .map(function (d) { return d.code; });
  }

  // ---- cart requests -------------------------------------------------------------------------
  function cartView() {
    var page = document.querySelector('cart-page');
    if (page) return { kind: 'page', el: page, id: page.dataset.sectionId };
    var drawer = document.querySelector('cart-drawer');
    if (drawer) return { kind: 'drawer', el: drawer, id: drawer.dataset.sectionId };
    return null;
  }

  function setCodes(list, withSections) {
    var body = { discount: list.join(',') };
    var view = withSections ? cartView() : null;
    if (view && view.id) {
      body.sections = view.id;
      body.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : root + 'cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update ' + r.status);
      return r.json();
    }).then(function (cart) {
      codes = workingCodes(cart);
      return { cart: cart, view: view };
    });
  }

  function readCodes() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { codes = workingCodes(cart); return codes; });
  }

  // Redraw the totals with the section HTML that came back with the update, the same way the
  // theme does after a quantity change. Falls back to the theme's slower refresh / a reload.
  function redraw(res) {
    var view = res && res.view;
    var html = view && res.cart && res.cart.sections && res.cart.sections[view.id];
    try {
      if (view && html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (view.kind === 'drawer' && typeof view.el.getTemplateContent === 'function') {
          var node = view.el.getTemplateContent(doc);
          if (node) {
            view.el.lastDrawerBody = node;
            view.el.mount();
            view.el.emit('update-nodes', { node: node });
            if (typeof view.el.updateEmptyStatus === 'function') view.el.updateEmptyStatus();
            return;
          }
        }
        if (view.kind === 'page' && typeof view.el.emit === 'function') {
          view.el.emit('update-nodes', { node: doc });
          return;
        }
      }
    } catch (e) { /* fall through */ }
    if (view && view.kind === 'page') { window.location.reload(); return; }
    if (view && typeof view.el.update === 'function') view.el.update();
  }

  // ---- UI --------------------------------------------------------------------------------------
  function renderCodes(box) {
    var list = box.querySelector('.raws-discount__codes');
    if (!list) return;
    list.textContent = '';
    (codes || []).forEach(function (code) {
      var li = document.createElement('li');
      li.className = 'raws-discount__code';
      var name = document.createElement('span');
      name.textContent = code;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'raws-discount__remove';
      x.setAttribute('data-code', code);
      x.setAttribute('aria-label', T.remove + ' ' + code);
      x.textContent = '×';
      li.appendChild(name);
      li.appendChild(x);
      list.appendChild(li);
    });
    list.hidden = !list.children.length;
  }

  function renderAll() {
    var boxes = document.querySelectorAll('.raws-discount');
    for (var i = 0; i < boxes.length; i++) renderCodes(boxes[i]);
  }

  function setBusy(box, on) {
    busy = on;
    box.classList.toggle('is-busy', on);
    var btn = box.querySelector('.raws-discount__btn');
    if (btn) btn.disabled = on;
    var view = cartView();
    if (view && view.kind === 'drawer' && on && typeof view.el.emit === 'function') {
      try { view.el.emit('start-update', {}); } catch (e) { /* ignore */ }
    }
  }

  function showError(box, on) {
    var err = box.querySelector('.raws-discount__error');
    if (err) err.hidden = !on;
  }

  function applyCode(box, code) {
    if (busy) return;
    showError(box, false);
    setBusy(box, true);
    var input = box.querySelector('.raws-discount__input');
    var before = null;
    (codes ? Promise.resolve(codes) : readCodes()).then(function (current) {
      before = current.slice();
      if (current.some(function (c) { return same(c, code); })) {
        if (input) input.value = '';
        setBusy(box, false);
        return;
      }
      return setCodes(current.concat(code), true).then(function (res) {
        var hit = ((res.cart && res.cart.discount_codes) || []).filter(function (d) {
          return d && d.code && same(d.code, code);
        })[0];
        if (hit && hit.applicable) {
          isOpen = false;
          setBusy(box, false);
          redraw(res);
          renderAll();
          return;
        }
        // The new code didn't apply: take it back off and keep the codes that work.
        return setCodes(before, false).then(function () {
          setBusy(box, false);
          renderAll();
          showError(box, true);
          if (input) input.focus();
        });
      });
    }).catch(function () {
      setBusy(box, false);
      showError(box, true);
    });
  }

  function removeCode(box, code) {
    if (busy) return;
    showError(box, false);
    setBusy(box, true);
    (codes ? Promise.resolve(codes) : readCodes()).then(function (current) {
      var keep = current.filter(function (c) { return !same(c, code); });
      return setCodes(keep, true).then(function (res) {
        setBusy(box, false);
        redraw(res);
        renderAll();
      });
    }).catch(function () { setBusy(box, false); });
  }

  function buildBox() {
    var box = document.createElement('div');
    box.className = 'raws-discount';
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'raws-discount__toggle';
    var label = document.createElement('span');
    label.textContent = T.ph;
    var plus = document.createElement('span');
    plus.className = 'raws-discount__plus';
    plus.setAttribute('aria-hidden', 'true');
    toggle.appendChild(label);
    toggle.appendChild(plus);
    var list = document.createElement('ul');
    list.className = 'raws-discount__codes';
    list.hidden = true;
    var form = document.createElement('form');
    form.className = 'raws-discount__form';
    form.setAttribute('novalidate', '');
    var input = document.createElement('input');
    input.className = 'raws-discount__input';
    input.type = 'text';
    input.name = 'raws_discount';
    input.autocomplete = 'off';
    input.setAttribute('autocapitalize', 'characters');
    input.spellcheck = false;
    input.placeholder = T.code;
    input.setAttribute('aria-label', T.code);
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.className = 'raws-discount__btn';
    btn.textContent = T.apply;
    form.appendChild(input);
    form.appendChild(btn);
    var err = document.createElement('p');
    err.className = 'raws-discount__error';
    err.setAttribute('role', 'alert');
    err.hidden = true;
    err.textContent = T.err;
    box.appendChild(toggle);
    box.appendChild(form);
    box.appendChild(err);
    box.appendChild(list);

    function setOpen(on, focus) {
      isOpen = on;
      form.hidden = !on;
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      box.classList.toggle('is-open', on);
      if (!on) err.hidden = true;
      if (on && focus) input.focus();
    }
    setOpen(isOpen, false);

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!isOpen, true);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var code = (input.value || '').trim();
      if (code) applyCode(box, code);
    });
    list.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('.raws-discount__remove') : null;
      if (x) { e.preventDefault(); removeCode(box, x.getAttribute('data-code')); }
    });
    // The drawer and cart page treat bubbling change events as quantity changes; keep ours local.
    ['change', 'input'].forEach(function (type) {
      box.addEventListener(type, function (e) { e.stopPropagation(); });
    });
    renderCodes(box);
    return box;
  }

  // ---- placement -------------------------------------------------------------------------------
  var syncTimer = null;
  function syncSoon() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { if (!busy) readCodes().then(renderAll).catch(function () {}); }, 300);
  }

  function place() {
    var added = false;
    // Drawer: first thing in the totals panel, right above the subtotal lines.
    var mains = document.querySelectorAll('cart-drawer .cart-drawer-subtotal__main-content');
    for (var i = 0; i < mains.length; i++) {
      var first = mains[i].firstElementChild;
      if (first && first.classList.contains('raws-discount')) continue;
      mains[i].insertAdjacentElement('afterbegin', buildBox());
      added = true;
    }
    // Cart page: top of the subtotal block.
    var blocks = document.querySelectorAll('cart-page cart-subtotal-block');
    for (var j = 0; j < blocks.length; j++) {
      if (blocks[j].querySelector('.raws-discount')) continue;
      blocks[j].insertAdjacentElement('afterbegin', buildBox());
      added = true;
    }
    if (added) syncSoon();
  }

  var queued = false;
  function queuePlace() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; place(); }, 30);
  }

  function start() {
    place();
    var targets = document.querySelectorAll('cart-drawer, cart-page');
    for (var k = 0; k < targets.length; k++) {
      new MutationObserver(queuePlace).observe(targets[k], { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();